// AlignUI · иллюстрация пустого состояния: счёт и разбивка по статьям
//
// Перенесена скриптом из набора дизайн-системы, руками не правится. Цвета заменены на
// семантические классы: под ними лежат переменные `--illustration-*`, у которых в тёмной
// теме своя ступень серого. Без этого картинка светилась бы белым пятном на тёмном экране.

import type { SVGProps } from 'react';

export function IllustrationРасход(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 148 149' fill='none' {...props}>
      <rect className='fill-illustration-weak-100' width='148' height='148' rx='74' />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M116.118 44.5246L91.3561 60.1001V89.3606C75.1981 89.3606 62.1023 76.258 62.1023 60.1001C62.1023 43.9421 75.1981 30.8461 91.356 30.8461C101.789 30.8461 110.942 36.3066 116.118 44.5246Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M120.61 60.1001H91.356L116.118 44.5247C118.964 49.0299 120.61 54.3752 120.61 60.1001Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M120.61 60.1003C120.61 76.2583 107.514 89.3609 91.3557 89.3609V60.1003H120.61Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M80.4832 57.7289H36.6228C32.8693 57.7289 29.8264 60.7717 29.8264 64.5253V113.618C29.8264 117.372 32.8693 120.415 36.6228 120.415H80.4832C84.2368 120.415 87.2796 117.372 87.2796 113.618V64.5253C87.2796 60.7717 84.2368 57.7289 80.4832 57.7289Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M78.206 63.4734H38.8991C37.4808 63.4734 36.3311 64.6232 36.3311 66.0415V74.4483C36.3311 75.8666 37.4808 77.0164 38.8991 77.0164H78.206C79.6243 77.0164 80.7741 75.8666 80.7741 74.4483V66.0415C80.7741 64.6232 79.6243 63.4734 78.206 63.4734Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M45.771 84.392H38.7059C37.394 84.392 36.3306 85.4554 36.3306 86.7673V88.6837C36.3306 89.9956 37.394 91.059 38.7059 91.059H45.771C47.0829 91.059 48.1463 89.9956 48.1463 88.6837V86.7673C48.1463 85.4554 47.0829 84.392 45.771 84.392Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M62.085 84.392H55.0199C53.708 84.392 52.6445 85.4555 52.6445 86.7673V88.6837C52.6445 89.9956 53.708 91.0591 55.0199 91.0591H62.085C63.3968 91.0591 64.4603 89.9956 64.4603 88.6837V86.7673C64.4603 85.4555 63.3968 84.392 62.085 84.392Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-strong-400 stroke-illustration-strong-400'
        d='M78.3982 84.392H71.3331C70.0212 84.392 68.9578 85.4554 68.9578 86.7673V88.6837C68.9578 89.9956 70.0212 91.059 71.3331 91.059H78.3982C79.7101 91.059 80.7735 89.9956 80.7735 88.6837V86.7673C80.7735 85.4554 79.7101 84.392 78.3982 84.392Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M45.771 96.197H38.7059C37.394 96.197 36.3306 97.2604 36.3306 98.5723V100.489C36.3306 101.801 37.394 102.864 38.7059 102.864H45.771C47.0829 102.864 48.1463 101.801 48.1463 100.489V98.5723C48.1463 97.2604 47.0829 96.197 45.771 96.197Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M62.085 96.1971H55.0199C53.708 96.1971 52.6445 97.2606 52.6445 98.5724V100.489C52.6445 101.801 53.708 102.864 55.0199 102.864H62.085C63.3968 102.864 64.4603 101.801 64.4603 100.489V98.5724C64.4603 97.2606 63.3968 96.1971 62.085 96.1971Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M78.3982 96.197H71.3331C70.0212 96.197 68.9578 97.2604 68.9578 98.5723V100.489C68.9578 101.801 70.0212 102.864 71.3331 102.864H78.3982C79.7101 102.864 80.7735 101.801 80.7735 100.489V98.5723C80.7735 97.2604 79.7101 96.197 78.3982 96.197Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M45.771 108.002H38.7059C37.394 108.002 36.3306 109.066 36.3306 110.378V112.294C36.3306 113.606 37.394 114.67 38.7059 114.67H45.771C47.0829 114.67 48.1463 113.606 48.1463 112.294V110.378C48.1463 109.066 47.0829 108.002 45.771 108.002Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-soft-200 stroke-illustration-strong-400'
        d='M62.085 108.002H55.0199C53.708 108.002 52.6445 109.066 52.6445 110.378V112.294C52.6445 113.606 53.708 114.669 55.0199 114.669H62.085C63.3968 114.669 64.4603 113.606 64.4603 112.294V110.378C64.4603 109.066 63.3968 108.002 62.085 108.002Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M78.3982 108.002H71.3331C70.0212 108.002 68.9578 109.066 68.9578 110.378V112.294C68.9578 113.606 70.0212 114.67 71.3331 114.67H78.3982C79.7101 114.67 80.7735 113.606 80.7735 112.294V110.378C80.7735 109.066 79.7101 108.002 78.3982 108.002Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M114.234 101.139L116.608 104.355C118.33 106.688 114.978 112.084 109.119 116.409C103.265 120.73 97.1207 122.343 95.3988 120.01L93.0249 116.794C93.4434 117.361 94.1291 117.697 95.0076 117.815C96.1136 117.967 97.5282 117.773 99.1161 117.266C101.431 116.535 104.122 115.138 106.749 113.199C109.376 111.259 111.504 109.099 112.89 107.099C113.842 105.731 114.445 104.436 114.625 103.335C114.771 102.46 114.652 101.706 114.234 101.139Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M114.234 101.139C114.652 101.706 114.771 102.46 114.625 103.335C114.444 104.436 113.842 105.731 112.89 107.099C111.504 109.099 109.376 111.259 106.749 113.199C104.122 115.138 101.431 116.535 99.116 117.266C97.5281 117.773 96.1135 117.967 95.0075 117.815C94.1291 117.697 93.4432 117.361 93.0248 116.794C91.3028 114.461 94.6543 109.066 100.508 104.744C106.368 100.419 112.512 98.8063 114.234 101.139Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-sub-300 stroke-illustration-strong-400'
        d='M48.0612 47.9063L44.9588 50.4267C42.7083 52.2551 37.1629 49.1574 32.5707 43.5046C27.9827 37.8572 26.0866 31.7948 28.3371 29.9665L31.4395 27.4461C30.8927 27.8904 30.5889 28.591 30.512 29.474C30.4113 30.5858 30.6706 31.99 31.2504 33.5526C32.0887 35.8308 33.6087 38.454 35.6678 40.9885C37.7269 43.5231 39.983 45.5482 42.0454 46.8404C43.4562 47.7282 44.7775 48.2695 45.8864 48.3987C46.7664 48.5043 47.5144 48.3506 48.0612 47.9063Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M48.0609 47.9063C47.5141 48.3506 46.766 48.5044 45.8861 48.3988C44.7772 48.2696 43.4559 47.7282 42.0451 46.8405C39.9827 45.5483 37.7265 43.5231 35.6675 40.9886C33.6085 38.4541 32.0884 35.8309 31.2501 33.5527C30.6703 31.99 30.411 30.5859 30.5117 29.4741C30.5886 28.5911 30.8923 27.8905 31.4392 27.4462C33.6898 25.6179 39.2352 28.7156 43.8232 34.363C48.4154 40.0158 50.3115 46.0779 48.0609 47.9063Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M86.5633 6.77256C86.5633 6.77256 81.1912 13.0749 87.4537 18.45C81.1911 13.0748 75.7762 19.3404 75.7762 19.3404C75.7762 19.3404 81.1483 13.038 74.8857 7.66282C81.1483 13.038 86.5633 6.77256 86.5633 6.77256Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        className='fill-illustration-white-0 stroke-illustration-strong-400'
        d='M52.4265 139.427C52.4265 139.427 44.1714 140.085 44.7989 148.314C44.1714 140.085 35.9121 140.686 35.9121 140.686C35.9121 140.686 44.1672 140.028 43.5397 131.799C44.1672 140.028 52.4265 139.427 52.4265 139.427Z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
